


















































import Vue from 'vue'
import Component from 'vue-class-component'
import FormTextField from '@/components/FormTextField.vue'
import { isBlank, isValidEmail, validatePassword } from '@/core/Utils'
import * as api from '@/services/ApiService'
import appManager from '@/services/AppManager'
import { extractResponseErrorMessage } from '@/services/ApiService'
import { RoutePaths } from '@/router'

@Component({
    components: {
        FormTextField
    }
})
export default class CreateCompanyAccountPanel extends Vue {
    firstName: string|null = null
    firstNameErrorMessage: string|null = null
    lastName: string|null = null
    lastNameErrorMessage: string|null = null
    emailValue: string|null = null
    emailErrorMessage: string|null = null
    password: string|null = null
    passwordErrorMessage: string|null = null
    confirmPassword: string|null = null
    confirmPasswordErrorMessage: string|null = null
    companyName: string|null = null
    companyNameErrorMessage: string|null = null
    companyEmail: string|null = null
    companyEmailErrorMessage: string|null = null
    formErrorMessage: string|null = null
    isCreating: boolean = false

    get email(): string|null {
        return this.emailValue
    }

    // noinspection JSUnusedGlobalSymbols
    set email(value: string|null) {
        this.emailValue = value
        this.companyEmail = value
    }

    async onCreatePressed(): Promise<void> {
        this.validatePage()
        if (this.formErrorMessage)
            return

        let isCreated = false
        this.isCreating = true

        try {
            // first create the company
            await api.createCompany({
                admin: {
                    firstName: this.firstName!,
                    lastName: this.lastName!,
                    email: this.email!,
                    password: this.password!
                },
                company: {
                    name: this.companyName!,
                    email: this.companyEmail!
                }
            })

            isCreated = true
        } catch (error) {
            this.formErrorMessage = extractResponseErrorMessage(error) || 'Error creating company. Please try again later.'
        }

        // go ahead and log in
        if (isCreated) {
            try {
                await appManager.userManager.signIn(this.email!, this.password!)

                // remove the extra query parameters
                await this.$router.replace(RoutePaths.PORTAL_HOME)
            } catch (error) {
                this.formErrorMessage = 'Your account was created, but there was an error logging in. Please go back and attempt to log in again.'
                this.isCreating = false
            }
        } else {
            this.isCreating = false
        }
    }

    validatePage() {
        // your info
        this.firstNameErrorMessage = isBlank(this.firstName) ? 'Specify a first name' : null
        this.lastNameErrorMessage = isBlank(this.lastName) ? 'Specify a last name' : null
        this.emailErrorMessage = !isValidEmail(this.email) ? 'Specify a valid email address' : null
        this.passwordErrorMessage = validatePassword(this.password)
        this.confirmPasswordErrorMessage = (this.password !== this.confirmPassword) ? 'Passwords do not match' : null

        // company info
        this.companyNameErrorMessage = isBlank(this.companyName) ? 'Specify a company name' : null
        this.companyEmailErrorMessage = !isValidEmail(this.companyEmail) ? 'Specify a valid email address' : null

        const hasError = !!this.firstNameErrorMessage ||
                !!this.lastNameErrorMessage ||
                !!this.emailErrorMessage ||
                !!this.passwordErrorMessage ||
                !!this.confirmPasswordErrorMessage ||
                !!this.companyNameErrorMessage ||
                !!this.companyEmailErrorMessage
        this.formErrorMessage = hasError ? 'Please correct the error above' : null
    }
}
